import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ConstantsModule } from 'src/app/main/shared/constants/constants.module';
import { MapConstants } from 'src/app/utils/map.constant';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { isNullOrUndefined } from 'util';

import { WindspeedMapConstants } from './utils/constant/winspeed-map.constant';
import { MapService } from './utils/service/map.service';
import { WindspeedService } from './utils/service/windspeed.service';

@Component({
  selector: 'app-forecast-windspeed',
  templateUrl: './forecast-windspeed.component.html',
  styleUrls: ['./forecast-windspeed.component.scss']
})
export class ForecastWindspeedComponent implements OnInit {

  component: any;
  forecastLength = '10';
  heatMapURLlist: any;
  windDataURLlist: any;
  otherOptions: {};
  stateName: any;
  layerList: any[];
  sourceSelected: any;
  primary: any;
  secondary: any;
  basinGeoJSONData: any;
  initializeBool = true;
  stateId = 'akbm';

  constructor(
    private http: HttpClient,
    private windService: WindspeedService,
    public constants: ConstantsModule) {
    this.stateName = ProjConstants.IDTOSTATENAMEMAPPING[this.stateId];
  }

  ngOnInit() {
    this.component = 'WIND';
    this.sourceSelected = 'IMD (GFS)';
    // this.primary = this.constants.SOURCE_WISE[this.sourceSelected].PrimarySourceType;
    // this.secondary = this.constants.SOURCE_WISE[this.sourceSelected].SecondarySourceType;
    this.getLayersList(WindspeedMapConstants.CommonLayers);
    this.getOtherOptions();
    this.otherOptions['reloadAllTimeLayers'] = true;
    this.getBasinGeoJSONData();
  }

  getLayersList(layers) {
    let layerList = [];
    layerList = layerList.concat(this.getCommonLayers(layers));
    layerList = layerList.concat(this.getHeatMapLayers());
    layerList = layerList.concat(this.getWindLayers());
    // layerList = layerList.concat(this.getCityLayers());
    this.layerList = layerList;
  }

  getOtherOptions() {
    const otherOptions = {};
    otherOptions['service'] = MapService;
    otherOptions['changeStateBoolean'] = false;
    otherOptions['addInverseMask'] = false;
    otherOptions['reloadAllTimeLayers'] = false;
    this.otherOptions = otherOptions;
  }

  getCommonLayers(layers) {
    const layerList: any = layers;
    for (const i in layerList) {
      if (!isNullOrUndefined(i)) {
        const layer = layerList[i];
        layer['stateName'] = this.stateName;
        if (layer.layerNameType) {
          if (layer['serviceType'] === 'VectorLayer') {
            layer['layerName'] = ProjConstants.STATE_TO_LAYERTYPE_NAME[this.stateName + '_' + layer.layerNameType];
          } else {
            layer['layerName'] = MapConstants.GEOSERVER_WORKSPACE_NAME + ':' +
              ProjConstants.STATE_TO_LAYERTYPE_NAME[this.stateName + '_' + layer.layerNameType];
          }
        }
      }
    }
    return layerList;
  }

  getHeatMapLayers() {
    let layerList = [];
    layerList = layerList.concat(this.create10HeatMapLayers());
    return layerList;
  }

  getWindLayers() {
    let layerList = [];
    layerList = layerList.concat(this.create10WindLayers());
    return layerList;
  }

  getCityLayers() {
    let layerList = [];
    layerList = layerList.concat(this.create10CityLayers());
    return layerList;
  }

  create10HeatMapLayers() {
    const tsarray: any = this.windService.get24HrsTimeStamps();
    const urls: any = [];
    for (const i in tsarray) {
      if (!isNullOrUndefined(i) && i === '0') {
        const layerObj = { ...WindspeedMapConstants.HeatMapOptions };
        layerObj['url'] = ProjConstants.API_URL + WindspeedMapConstants.HeatMapUrl + 'IMD_LONG_RANGE' + '/' +
          'IMD_LONG_RANGE' + '/' + 'WIND' + '/' + tsarray[i]['timeStamp'] + '/' + '24' + '/3hr' + '/null';
        layerObj['groupName'] = tsarray[i]['timeStamp'].toString();
        if (i === '0') {
          layerObj['setDefault'] = 'true';
        } else {
          layerObj['setDefault'] = 'false';
        }
        layerObj['stateName'] = this.stateName;
        layerObj['view'] = 'Admin';
        layerObj['time'] = '10';
        layerObj['timeLineName'] = tsarray[i]['timeLineName'];
        layerObj['timeLinePos'] = tsarray[i]['timeLinePos'];
        layerObj['leftSideName'] = tsarray[i]['leftSideName'];
        layerObj['layerName'] = 'Wind Heat Map';
        urls.push(layerObj);
        // const basinLayerObj = { ...layerObj };
        // basinLayerObj['view'] = 'Basin';
        // urls.push(basinLayerObj);
      }
    }
    return urls;
  }

  create10WindLayers() {
    const tsarray: any = this.windService.get24HrsTimeStamps();
    const urls: any = [];
    for (const i in tsarray) {
      if (!isNullOrUndefined(i) && i === '0') {
        const layerObj = { ...WindspeedMapConstants.WindLayerOptions };
        layerObj['url'] = ProjConstants.API_URL + WindspeedMapConstants.WindUrl + 'IMD_LONG_RANGE' + '/' +
          'IMD_LONG_RANGE' + '/' + tsarray[i]['timeStamp'] + '/' + '24' + '/3hr';
        layerObj['groupName'] = tsarray[i]['timeStamp'].toString();
        if (i === '0') {
          layerObj['setDefault'] = 'true';
        } else {
          layerObj['setDefault'] = 'false';
        }
        layerObj['time'] = '10';
        layerObj['view'] = 'Admin';
        layerObj['timeLinePos'] = tsarray[i]['timeLinePos'];
        layerObj['stateName'] = this.stateName;
        urls.push(layerObj);
        // const basinLayerObj = { ...layerObj };
        // basinLayerObj['view'] = 'Basin';
        // urls.push(basinLayerObj);
      }
    }
    return urls;
  }

  create10CityLayers() {
    const tsarray: any = this.windService.get24HrsTimeStamps();
    const urls: any = [];
    for (const i in tsarray) {
      if (!isNullOrUndefined(i) && i === '0') {
        const layerObj = { ...WindspeedMapConstants.CityLayerOptions };
        layerObj['url'] = ProjConstants.API_URL + WindspeedMapConstants.CityURLConstant + '/' + this.primary + '/' +
          this.secondary + '/' + WindspeedMapConstants.componentName + '/' + tsarray[i]['timeStamp'] + '/' +
          '24' + '/' + '6hr' + '/CITY/{x}/{y}/{z}';
        layerObj['groupName'] = tsarray[i]['timeStamp'].toString();
        if (i === '0') {
          layerObj['setDefault'] = 'true';
        } else {
          layerObj['setDefault'] = 'false';
        }
        layerObj['type'] = 'Time';
        layerObj['time'] = '10';
        layerObj['view'] = 'Admin';
        layerObj['timeLinePos'] = tsarray[i]['timeLinePos'];
        layerObj['stateName'] = this.stateName;
        layerObj['timeStamp'] = tsarray[i]['timeStamp'].toString();
        urls.push(layerObj);
      }
    }
    return urls;
  }

  getBasinGeoJSONData() {
    this.http.get(WindspeedMapConstants.basinGeoJSONUrl).subscribe((data: any) => {
      if (data) {
        this.basinGeoJSONData = data;
        this.getOtherOptions();
      }
    });
  }

}
